import { Navigate } from 'react-router-dom';
import { useAuthGate } from './useAuthGate';

/** Saha personeli (barista / müdür). İşletme sahibi (admin) /dashboard’a yönlendirilir. */
function BaristaProtectedRoute({ children }) {
  const kind = useAuthGate();

  if (kind === 'loading') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#94a3b8', fontSize: '0.9rem' }}>
        Loading…
      </div>
    );
  }

  if (kind === 'mfa_required') {
    return <Navigate to="/login" replace state={{ mfaRequired: true }} />;
  }

  if (kind === 'anon' || kind === 'forbidden') {
    return <Navigate to="/login" replace />;
  }

  if (kind === 'admin' || kind === 'delegate') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default BaristaProtectedRoute;
